import { render, staticRenderFns } from "./ProductPool.vue?vue&type=template&id=260dc814&scoped=true"
import script from "./ProductPool.vue?vue&type=script&lang=js"
export * from "./ProductPool.vue?vue&type=script&lang=js"
import style0 from "./ProductPool.vue?vue&type=style&index=0&id=260dc814&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "260dc814",
  null
  
)

export default component.exports